import React__default from 'react';
import { DividerStyleEnum, Alignment } from '@teko/types/shared';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';
import { pixelParse } from '../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = DividerStyleEnum.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ React__default.createElement(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align
      });
    }
    return /* @__PURE__ */ React__default.createElement(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent
    }, /* @__PURE__ */ React__default.createElement("span", null, children));
  };
  return /* @__PURE__ */ React__default.createElement(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    gap
  }), renderSeparator());
};
const WrapperDivider = styled.div(({ gap }) => [
  CommonStyles,
  `
  --divider-gap: ${pixelParse(gap != null ? gap : "") || "12px"};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`
]);
const transformAlign = (align) => {
  switch (align) {
    case Alignment.center:
      return "margin: 0 auto;";
    case Alignment.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent) => {
  const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
  switch (alignContent) {
    case Alignment.left:
      return `
          &:after ${css}
        `;
    case Alignment.right:
      return `
          &:before ${css}
        `;
    default:
      return `
          &:after, &:before ${css}
        `;
  }
};
const WrapperSeparator = styled.div(({
  width,
  weight,
  dividerStyle,
  color,
  align,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : theme == null ? void 0 : theme.colors.divider};
  --divider-border-width: ${weight || "1px"};
  display: flex;
  width: ${width ? width : "100%"};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align || Alignment.left)}
`);
const WrapperSeparatorText = styled.div(({
  width,
  weight,
  dividerStyle,
  color = "black",
  align,
  alignContent,
  spacingContent,
  theme
}) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${(theme == null ? void 0 : theme.colors[color]) || color};
  --divider-border-width: ${weight || "1px"};
  --divider-content-spacing: ${spacingContent || "10px"};
  display: flex;
  align-items: center;
  width: ${width ? width : "100%"};
  ${transformAlign(align || Alignment.left)}
  ${transformAlignContent(alignContent || Alignment.center)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === "left" ? "0" : "var(--divider-content-spacing)"};
    margin-right: ${alignContent === "right" ? "0" : "var(--divider-content-spacing)"};
  }
`);
Divider.displayName = "Divider";

export { Divider };
